import { NavLink } from "react-router-dom";
import {
  FileText,
  CreditCard,
  RefreshCw,
  LogOut,
  ChevronLeft,
  MessageSquare,
  Star
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

export function AdminSidebar({ onClose, collapsed, onToggle }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const menuItems = [
    { icon: FileText, label: "Applications", path: "/applications" },
    { icon: RefreshCw, label: "Renew", path: "/renew" },
    { icon: CreditCard, label: "Payments", path: "/payments" },
    { icon: MessageSquare, label: "Contact", path: "/contact-messages" },
    { icon: Star, label: "Reviews", path: "/reviews" },
  ];

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Logo with Toggle */}
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        <div 
          className={`flex items-center gap-3 ${collapsed ? 'justify-center w-full cursor-pointer hover:opacity-80' : ''}`}
          onClick={collapsed ? onToggle : undefined}
        >
          <div className="w-10 h-10  rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0">
            <img 
              src={logo} 
              alt="AIFIAWU Logo" 
              className="w-full h-full object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<span class="text-white font-bold text-lg">AIF</span>';
              }}
            />
          </div>
          {!collapsed && (
            <div className="overflow-hidden transition-all">
              <h2 className="text-lg font-bold text-[#111111] truncate">AIFIAWU</h2>
              <p className="text-xs text-gray-500 truncate">Admin Panel</p>
            </div>
          )}
        </div>
        
        {/* Toggle button - visible only when expanded (to collapse) */}
        {!collapsed && (
          <button 
            onClick={onToggle}
            className="hidden lg:flex p-1.5 rounded-lg hover:bg-gray-100 text-gray-500"
            title="Collapse sidebar"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Menu Items */}
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg transition group ${
                isActive
                  ? "bg-[#C46A1B] text-white"
                  : "text-gray-700 hover:bg-gray-100 hover:text-[#111111]"
              } ${collapsed ? 'justify-center' : ''}`
            }
            title={collapsed ? item.label : undefined}
          >
            <item.icon className={`w-5 h-5 flex-shrink-0 ${
              collapsed ? 'mx-auto' : ''
            }`} />
            {!collapsed && <span className="text-sm font-medium">{item.label}</span>}
            
            {/* Tooltip for collapsed mode */}
            {collapsed && (
              <span className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50 shadow-lg">
                {item.label}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-3 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className={`flex items-center gap-3 px-3 py-2.5 w-full text-gray-700 hover:bg-gray-100 hover:text-[#111111] rounded-lg transition group ${
            collapsed ? 'justify-center' : ''
          }`}
          title={collapsed ? "Logout" : undefined}
        >
          <LogOut className="w-5 h-5 flex-shrink-0" />
          {!collapsed && <span className="text-sm font-medium">Logout</span>}
          
          {/* Tooltip for collapsed mode */}
          {collapsed && (
            <span className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50 shadow-lg">
              Logout
            </span>
          )}
        </button>
      </div>
    </div>
  );
}